<script lang="ts" setup>
import type {EventSearch, EventSimple} from "~/types/event";

definePageMeta({
  title: 'Home',
});

const {visitorId} = useVisitor()
const {findAllEventsBySearch} = useEvent()
const {geolocation, filterCity} = useNavSearch()
const search = reactive<EventSearch>({
  query: null,
  city: null,
  categorySlug: null,
  subCategorySlug: null,
  startDate: null,
  latitude: null,
  longitude: null,
  distanceAreaMeters: null,
  sortBy: 'startAt',
  page: 0,
  size: 100
})

const {data: events, pending, refresh} = await useAsyncData<EventSimple[]>(
    'list-home-events-' + visitorId.value,
    async () => {
      const allEvents = await findAllEventsBySearch(search)
      return allEvents.content
    }
);

watch([filterCity, geolocation], () => {
  if (filterCity.value) search.city = filterCity.value
  if (geolocation.value.latitude && geolocation.value.longitude) {
    search.latitude = geolocation.value.latitude
    search.longitude = geolocation.value.longitude
    search.distanceAreaMeters = 50
  }
  refresh()
});

</script>
<template>
  <HomeCategories/>
  <EventCarrousel v-if="!pending && (events || []).length > 0" :events="events" title="Em alta" class="mt-5"/>
  <div v-else class="w-100 text-center mb-5 mt-3"><h5>Sem resultados</h5></div>
</template>
